import { lazy, Suspense } from 'react';
import './charts.css';
import { ChartPlaceholder } from './ChartPlaceholder';
import type { PriceChartProps } from './PriceChartImpl';

// Lazy-grens: de ECharts-bundel zit hierachter en valt daarmee uit de
// kritieke laadketen. De implementatie staat in PriceChartImpl.tsx; dit
// bestand houdt het import-pad ('components/charts/PriceChart') ongewijzigd
// voor HomePage en de tests.
const PriceChartImpl = lazy(() =>
  import('./PriceChartImpl').then(m => ({ default: m.PriceChart })),
);

export { computePriceYMax } from './priceScale';
export type { PriceChartProps } from './PriceChartImpl';

export function PriceChart(props: PriceChartProps) {
  return (
    <Suspense fallback={<ChartPlaceholder />}>
      <PriceChartImpl {...props} />
    </Suspense>
  );
}
